









































import { Component, Vue, Prop } from 'vue-property-decorator';
import { InputType } from '@/enums/InputType';
import CharacterCounter from '@/components/CharacterCounter.vue';
import { ICurrency } from '@/types/Currency';

@Component({
  components: {
    CharacterCounter,
  },
})
export default class Input extends Vue {
  @Prop() value: string | number;
  @Prop() type: InputType;
  @Prop() label: string;
  @Prop() disabled?: boolean;
  @Prop({ default: true }) translate?: boolean;
  @Prop() completed?: boolean;
  @Prop({ default: false }) doFocus?: boolean;
  @Prop() maxLength: number;
  @Prop() min?: number;
  @Prop() max?: number;
  @Prop() showCharacterCounter: boolean;
  @Prop({ default: false }) invalid?: boolean;
  @Prop({ default: false }) required?: boolean;
  @Prop({ default: '' }) autocomplete?: string;
  @Prop({ default: '' }) placeholder?: string;
  @Prop({ default: false }) isBoxed?: boolean;
  @Prop({ default: '' }) icon?: string;
  @Prop({ default: false }) dark: boolean;
  @Prop({ default: null }) currency?: ICurrency;

  setFocus() {
    const element: HTMLElement = this.$refs.input as HTMLElement;
    element.focus();
  }

  get inputLabel(): string {
    return this.translate ? this.$t(this.label).toString() : this.label;
  }

  get computedValue(): string | number {
    if (this.type === InputType.Number) {
      return this.value;
    }
    return this.maxLength && !!this.value
      ? this.value.toString().substring(0, this.maxLength)
      : this.value;
  }

  get fieldIsActive(): boolean {
    return !!this.computedValue || this.computedValue === 0;
  }

  get currencyLength(): string {
    switch (this.currency.symbol.length) {
      case 1:
        return 'small';
      case 2:
        return 'medium';
      case 3:
        return 'large';
      default:
        return 'small';
    }
  }

  get currencyPadding(): string {
    if (!this.currency) {
      return '';
    }
    if (this.currency.position) {
      return `currency-padding-right-${this.currencyLength}`;
    }
    return `currency-padding-left-${this.currencyLength}`;
  }

  get currencyPosition(): string {
    if (this.currency) {
      if (this.currency.position) {
        return 'currency-position-right';
      } else {
        return 'currency-position-left';
      }
    }
    return '';
  }

  get safeMaxLength(): string {
    return this.maxLength !== undefined && this.maxLength.toString();
  }

  handleInput(event: KeyboardEvent) {
    const target = event.target as HTMLInputElement;
    if (this.type !== InputType.Number) {
      this.$emit('input', target.value);
      return;
    }
    const input: number = this.getValueWithinBounds(parseInt(target.value));

    target.value = input.toString();
    this.$emit('input', input);
  }

  getValueWithinBounds(value: number): number {
    if (this.min != null && value < this.min) {
      return this.min;
    }
    if (this.max != null && value > this.max) {
      return this.max;
    }
    return value;
  }

  handleChange(event: any) {
    this.$emit('change', event);
  }

  handleBlur(value: string) {
    const blurValue: string | number = this.type === InputType.Number ? parseInt(value) : value;
    this.$emit('blur', blurValue);
  }

  handleFocus(event: any) {
    this.$emit('focus', event);
  }

  handleClick(event: any) {
    this.$emit('click', event);
  }

  handleArrowDown(event: any) {
    this.$emit('keyDownDown', event);
  }

  handleArrowUp(event: any) {
    this.$emit('keyDownUp', event);
  }

  handleEnter(event: any) {
    this.$emit('keyDownEnter', event);
  }

  mounted() {
    if (this.doFocus) {
      this.setFocus();
    }
  }
}
